import {Image, List, Modal, Skeleton} from 'antd';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

const LowStockModal = ({
  isModalOpen,
  setIsModalOpen,
  lowStockProducts = [],
  isLoading,
}) => {
  const navigate = useNavigate();

  const handleClose = () => setIsModalOpen(false);
  const normalizeImageUrl = (url = '') => {
    if (!url) {return '';}

    if (url.includes('dropbox.com')) {
      return url
        .replace('www.dropbox.com', 'dl.dropboxusercontent.com')
        .replace('?dl=0', '');
    }

    return url;
  };

  const getProductImage = item => {
    if (item?.variants?.length) {
      for (const variant of item.variants) {
        if (variant?.images?.length) {
          return normalizeImageUrl(variant.images[0]);
        }
      }
    }

    if (Array.isArray(item?.imageUrl) && item.imageUrl.length) {
      return normalizeImageUrl(item.imageUrl[0]);
    }

    if (typeof item?.imageUrl === 'string') {
      return normalizeImageUrl(item.imageUrl);
    }

    return '';
  };

  return (
    <Modal
      title={'Products Low in Stock'}
      open={isModalOpen}
      onOk={handleClose}
      onCancel={handleClose } 
      width={700}
      bodyStyle={{maxHeight: '400px', overflowY: 'auto'}}
    >
      {isLoading ? (
        <Skeleton active />
      ) : lowStockProducts.length === 0 ? (
        <p>No products are low in stock 🎉</p>
      ) : (
        <List
          itemLayout={'horizontal'}
          dataSource={lowStockProducts}
          renderItem={item => {
            const allSizes =
  item?.variants?.flatMap(variant => variant?.sizes || []) || [];

            const lowSizes = allSizes.filter(s => Number(s?.quantity) <= 5);

            const hasSizes = allSizes.length > 0;

            return (
              <List.Item
                style={{cursor: 'pointer'}}
                onClick={() =>
                  navigate('/admin/team/product', {
                    state: {
                      openEdit: true,
                      productId: item.id,
                    },
                  })
                }
              >
                <List.Item.Meta
                  avatar={(
                    <Image
                      preview={false}
                      width={50}
                      src={getProductImage(item)}
                      fallback={'https://via.placeholder.com/50'}
                    />

                  )}
                  title={<b>{item?.productName || 'Unnamed Product'}</b>}
                  description={
                    hasSizes ? (
                      lowSizes.length > 0 ? (
                        <div style={{fontSize: '13px', color: '#666'}}>
                          <div className={'font-medium'}>Sizes low in stock:</div>
                          {lowSizes.map((s, index) => (
                            <div key={index}>
            Size : {s.size || 'N/A' }  , Qty: {s.quantity}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p>No sizes below threshold</p>
                      )
                    ) : (
                      <div style={{fontSize: '13px', color: '#666'}}>
      Qty: {item?.quantity ?? 'N/A'}
                      </div>
                    )
                  }
                />
              </List.Item>
            );
          }}
        />
      )}
    </Modal>
  );
};

LowStockModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  lowStockProducts: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default LowStockModal;
